import i18n from "../../utils/i18n";
export default {
  data() {
    return {
      advertListLoading: false,
      activeTab: "screenSaver",
      searchKeyword: "",
      filterType: "",
      screenSaverAdverts: [], //屏幕保护广告
      topBannerAdverts: [], //顶部banner广告
      externalScreenAdverts: [], //外部屏幕广告
      advertList: [],
      page: {
        pageIndex: 1,
        pageSize: 12,
        total: 0
      }
    };
  },
  methods: {
    async loadAdvertList() {
      this.advertListLoading = true;
      try {
        const params = {
          pageIndex: this.page.pageIndex,
          pageSize: this.page.pageSize
        };

        if (this.searchKeyword) {
          params.head = this.searchKeyword;
        }

        if (this.filterType !== "") {
          params.type = this.filterType;
        }

        const res = await this.$api.request(this.$url.Adverts.page, this.$method.get, params);

        if (res.code === 0 && res.data) {
          this.advertList = res.data.records || [];
          this.page.total = parseInt(res.data.total) || 0;
          this.page.pageIndex = parseInt(res.data.current) || 1;
        }
      } catch (error) {
        console.error(i18n.t("advert-config.advertConfigMixin.082886-0"), error);
        this.$message.error(i18n.t("advert-config.advertConfigMixin.082886-1"));
      } finally {
        this.advertListLoading = false;
      }
    },

    handleSearch() {
      this.page.pageIndex = 1;
      this.loadAdvertList();
    },

    handleReset() {
      this.searchKeyword = "";
      this.filterType = "";
      this.page.pageIndex = 1;
      this.loadAdvertList();
    },

    handleSizeChange(size) {
      this.page.pageSize = size;
      this.page.pageIndex = 1;
      this.loadAdvertList();
    },

    handlePageChange(page) {
      this.page.pageIndex = page;
      this.loadAdvertList();
    },

    addToCurrentSlot(advert) {
      console.log(advert);
      const slotMap = {
        screenSaver: this.screenSaverAdverts,
        topBanner: this.topBannerAdverts,
        externalScreen: this.externalScreenAdverts
      };

      const targetSlot = slotMap[this.activeTab];

      if (targetSlot.some(item => item.id === advert.id)) {
        this.$message.warning(i18n.t("advert-config.advertConfigMixin.082886-2"));
        return;
      }

      if (targetSlot.length > 0) {
        const firstAdvertType = String(targetSlot[0].type);
        const currentAdvertType = String(advert.type);

        if (firstAdvertType !== currentAdvertType) {
          const typeName = this.getAdvertTypeName(firstAdvertType);
          this.$message.warning(i18n.t("advert-config.advertConfigMixin.082886-3", [typeName]));
          return;
        }
      }

      targetSlot.push({ ...advert });
      this.$message.success(i18n.t("advert-config.advertConfigMixin.082886-4"));
    },

    removeFromSlot(slotKey, index) {
      const slotMap = {
        screenSaver: this.screenSaverAdverts,
        topBanner: this.topBannerAdverts,
        externalScreen: this.externalScreenAdverts
      };

      slotMap[slotKey].splice(index, 1);
      this.$message.success(i18n.t("advert-config.advertConfigMixin.082886-5"));
    },

    removeFromCurrentSlot(advertId) {
      const targetSlot = this.getCurrentTabAdverts();
      const targetIndex = targetSlot.findIndex(item => item.id === advertId);

      if (targetIndex === -1) {
        return;
      }

      targetSlot.splice(targetIndex, 1);
      this.$message.success(i18n.t("advert-config.advertConfigMixin.082886-5"));
    },

    clearSlot(slotKey) {
      this.$confirm(
        i18n.t("advert-config.advertConfigMixin.082886-6"),
        i18n.t("advert-config.advertConfigMixin.082886-7"),
        {
          confirmButtonText: i18n.t("advert-config.advertConfigMixin.082886-8"),
          cancelButtonText: i18n.t("advert-config.advertConfigMixin.082886-9"),
          type: "warning"
        }
      )
        .then(() => {
          const slotMap = {
            screenSaver: "screenSaverAdverts",
            topBanner: "topBannerAdverts",
            externalScreen: "externalScreenAdverts"
          };

          this[slotMap[slotKey]] = [];
          this.$message.success(i18n.t("advert-config.advertConfigMixin.082886-10"));
        })
        .catch(() => {});
    },

    getAdvertTypeName(type) {
      const typeMap = {
        0: i18n.t("advert-config.advertConfigMixin.082886-11"),
        1: i18n.t("advert-config.advertConfigMixin.082886-12"),
        2: i18n.t("advert-config.advertConfigMixin.082886-14")
      };
      return typeMap[String(type)] || i18n.t("advert-config.advertConfigMixin.082886-15");
    },

    getCurrentTabAdverts() {
      const slotMap = {
        screenSaver: this.screenSaverAdverts,
        topBanner: this.topBannerAdverts,
        externalScreen: this.externalScreenAdverts
      };
      return slotMap[this.activeTab] || [];
    },

    getAllAdvertsObject() {
      return {
        screenSaver: this.screenSaverAdverts,
        topBanner: this.topBannerAdverts,
        externalScreen: this.externalScreenAdverts
      };
    }
  }
};
